﻿/*
This function, updateStickyOffsets, is responsible for updating the position and z-index of sticky elements on the page. 
It iterates through all elements with the class 'sticky' and recalculates their top offset based on the total offset contributed by 
their sticky parent elements and siblings.

Function updateStickyOffsets():
- Selects all elements with the class 'sticky' using document.querySelectorAll().
- Calculates the initial z-index value based on the number of sticky elements found.
- Iterates over each sticky element.
	- Calls getTotalStickyOffset function to calculate the total offset contributed by sticky parent elements and siblings.
	- Updates the top offset of the sticky element using the calculated total offset.
	- Decrements the z-index value for each sticky element.
- getTotalStickyOffset function is called to calculate the total offset contributed by sticky parent elements and siblings for each sticky element.
- This function is initially called on page load and subsequently whenever the window is resized.

Function getTotalStickyOffset(element):
- Calculates the total offset contributed by sticky parent elements and siblings for the given element.
- Checks if the element or its parent is not an element node, returning 0 if true.
- Retrieves the parent element and initializes the offset variable.
- Checks if the parent itself is sticky and adds its offsetHeight to the total offset.
- Checks if the parent creates a new stacking context based on CSS properties.
	- If a new stacking context is found, it logs a message and returns without calculating the offset.
- Iterates through siblings of the parent, adding the offsetHeight of sticky siblings to the total offset.
- Recursively calls itself with the parent element to calculate offsets contributed by parent elements.
- Returns the total offset.
*/
function updateStickyOffsets() {
	const stickies = document.querySelectorAll('.sticky');

	let zIndex = 100 + stickies.length;

	stickies.forEach(sticky => {
		var total = getTotalStickyOffset(sticky);
		// Update the top offset of the sticky element
		sticky.style.top = total + 'px';
		sticky.style.zIndex = zIndex--;
	});
}
function getTotalStickyOffset(element) {
	if (!element || !element.parentNode || element.parentNode.nodeType !== Node.ELEMENT_NODE) {
		return 0; // Base case: if element or its parent is not an element node, return 0
	}

	const parent = element.parentNode;
	let offset = 0;

	// Check if the parent itself is sticky
	if (parent.classList && parent.classList.contains('sticky') && parent !== element) {
		offset += parent.offsetHeight;
	}

	// Check if the parent creates a new stacking context
	const parentComputedStyle = window.getComputedStyle(parent);
	if (parentComputedStyle && parentComputedStyle.getPropertyValue) {

		const createsStackingContext = parentComputedStyle.getPropertyValue('position') !== 'static' || parentComputedStyle.getPropertyValue('overflow') !== 'visible' || parentComputedStyle.getPropertyValue('transform') !== 'none' || parentComputedStyle.getPropertyValue('perspective') !== 'none' || parentComputedStyle.getPropertyValue('isolation') === 'isolate' || parentComputedStyle.getPropertyValue('mix-blend-mode') !== 'normal' || parentComputedStyle.getPropertyValue('filter') !== 'none' || ['absolute', 'fixed'].includes(parentComputedStyle.getPropertyValue('position'));

		if (createsStackingContext) {
			console.log("new stacking context found");
			return;
		}
	}

	// Add the offset contributed by siblings
	let sibling = parent.firstChild;
	while (sibling && sibling !== element) {
		if (sibling !== element && sibling.nodeType === 1 && sibling.classList && sibling.classList.contains('sticky')) {
			offset += sibling.offsetHeight;
		}
		sibling = sibling.nextSibling;
	}

	// Recursively call the function with the parent element
	return offset + getTotalStickyOffset(parent);
}

// Call the function initially and on window resize
window.addEventListener('load', updateStickyOffsets);
window.addEventListener('resize', updateStickyOffsets);